import { create } from "zustand";

export interface PaymentAccountSlice {
  isRedirecting: boolean;
  setRedirecting: (value: boolean) => void;
}

export const usePaymentAccountStore = create<PaymentAccountSlice>((set) => ({
  isRedirecting: false,
  setRedirecting: (value) => set({ isRedirecting: value }),
}));
